import React, { useState } from "react";
import PropTypes from "prop-types";

const SelectInput = ({ options, label, model, field, setValue }) => {
  const [validClass, setValidClass] = useState("");

  const onChange = (value) => {
    if (value != "") {
      setValidClass("border-green-500");
    } else {
      setValidClass("border-red-500");
    }
    setValue(value);
  };
  const optionElements = options.map(function (el, index) {
    return (
      <option key={index + 1} value={el.value}>
        {el.label}
      </option>
    );
  });

  return (
    <div>
      <label
        htmlFor={`${model}_${field}`}
        className="block uppercase tracking-wide text-blueGray-800 text-base font-bold mb-2"
      >
        {label}
      </label>
      <div className="relative">
        <select
          onChange={(event) => {
            onChange(event.target.value);
          }}
          name={`${model}[${field}]`}
          id={`${model}_${field}`}
          className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${validClass}`}
        >
          <option key="0" value=""></option>
          {optionElements}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg
            className="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

SelectInput.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  model: PropTypes.string,
  field: PropTypes.string,
  required: PropTypes.bool,
};

export default SelectInput;
